/**
 * React Query cache key factories for ASN (Advanced Shipping Notice) data.
 * Use these keys with `useQuery`, `invalidateQueries`, and related APIs so
 * fetches and mutations stay consistent.
 */
export const ASN_QUERY_KEYS = {
  all: (userId: string) => ['asn', userId] as const,
  byPoNumber: (userId: string, poNumber: string) =>
    [...ASN_QUERY_KEYS.all(userId), poNumber] as const,
};
